export const addHashToPropertyTracking = (propertyWithId?: string) => {
  const formatToTrackingWithHash = 'hashed|';
  return `${formatToTrackingWithHash}${propertyWithId}`;
};
